<template>
  <q-select
    emit-value
    map-options
    option-label="name"
    option-value="id"
    :options="categories"
  >
    <template #option="scope">
      <q-item-wrapper
        v-bind="scope.itemProps"
        label-class="text-ellipsis text-bold"
        clickable
        :icon-style="{'color': scope.opt.color}"
        :label-style="{'color': readableProfileColor(scope.opt.color)}"
        :icon="scope.opt.icon"
        :label="scope.opt.name"
        :label-title="scope.opt.name"
        :title="scope.opt.name"
      />
    </template>

    <template #selected-item="scope">
      <q-item-section v-if="scope.opt.icon" side>
        <q-icon
          :name="scope.opt.icon"
          :style="{'color': scope.opt.color}"
        />
      </q-item-section>
      <q-item-section>
        <q-item-label
          :lines="1"
          :style="{'color': readableProfileColor(scope.opt.color)}"
          class="text-bold"
        >
          {{ scope.opt.name }}
        </q-item-label>
      </q-item-section>
    </template>
  </q-select>
</template>

<script>
export default {
  props: {
    withNoCat: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    needsReloading () {
      return this.$store.getters['filecategories/needsReloading']
    },
    categories () {
      return [
        ...this.withNoCat ? [{ name: 'All Files', id: -1 }] : [],
        { name: 'Home', id: null, icon: 'mdi-home', color: '#000000' },
        ...this.$store.getters['filecategories/getFileCategories']
      ]
    }
  },
  watch: {
    'needsReloading' (val) {
      if (val) {
        this.fetchCategories()
      }
    }
  },
  methods: {
    fetchCategories () {
      this.$store.dispatch('filecategories/getFileCategories')
    }
  },
  mounted () {
    this.fetchCategories()
  }
}
</script>
